<shell-layout-errors-center>
  <img class="error__img" src="assets/img/errors/error__without_loan.svg" alt="" />
  <ui-text class="error__title" color="blue-500" size="h4" weight="semibold"
    >¡Aún no cuentas con un préstamo preaprobado!
  </ui-text>

  <ui-text class="error__description mb-3" color="blue-300">
    Pero tranquilo, anímate a crear una
    <ui-text class="error__description" weight="bold" color="blue-500">cuenta de ahorro</ui-text>
    <br />
    y no olvides visitar la agencia más cercana para conocer si tenemos un producto disponible para
    ti.
  </ui-text>
  <ui-button
    (clicked)="closeModal()"
    class="error__action"
    type="primary"
    label="Abrir una cuenta de ahorro"
  ></ui-button>
</shell-layout-errors-center>
